import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { ConnectionLivestockService } from 'src/app/common/_services/connectionLivestock.service';
import { ActivitiesTableService } from 'src/app/sustainabilityV2/regenerative/path-details/data/common-services/activitiesTables.services';
import { FarmWeatherLocationService } from 'src/app/common/_services/farmWeatherLocation.service';
import { WeatherHubService } from 'src/app/common/_services/weatherHub.service';
import { GeoCodingService } from 'src/app/common/_services/geocoding.service';
import { environment } from 'src/environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AllynavService } from 'src/app/common/_services/allynav.service';
import { CftService } from 'src/app/sustainabilityV2/common/services/cft.service';
import { SearchfilterDateRangePipe } from '../../pipe/searchfilterDateRange/searchfilterDateRange.pipe';
import {
  AgrirouterService,
  AlertGroupService,
  AuthenticationService,
  CertificationDocService,
  CertificationService,
  CommodityService,
  CommonService,
  CompanyAddressService,
  CompanyContactService,
  CompanyService,
  ContainerActivityService,
  ContainerService,
  CropMetricsService,
  CropService,
  CustomerService,
  DataService,
  DeviceDataService,
  DeviceService,
  EmployeeDocService,
  EmployeeService,
  EquipmentActivityService,
  EquipmentService,
  FarmCadastralSheetService,
  FarmService,
  FieldActivityDeprecatedService,
  FieldActivityMultipleService,
  FieldGroupService,
  FieldService,
  FormService,
  GeoserverService,
  InsuranceDocService,
  InsuranceService,
  InvoiceDocService,
  LandRegistryService,
  LivestockCoreDataService,
  LoadService,
  MachineActivityService,
  MapLegendaService,
  MapService,
  MessageService,
  NoteService,
  NotificationService,
  ParcelService,
  PaymentService,
  PersonAddressService,
  PersonContactService,
  PlantService,
  ProductService,
  SecurityDocService,
  SecurityService,
  StoreModelService,
  SupplierService,
  TagService,
  UploadService,
  UserGroupService,
  UserService,
  UsersroleService,
  WarehouseService,
} from '../../common/_services';
import { SatelliteService } from '../../common/_services/satellite/satellite.service';
import { PostService } from '../../common/_services/cms/post.service';
import { SearchfilterPipe } from '../../pipe/searchfilter/searchfilter.pipe';
import { CapitalizePipe } from '../../pipe/capitalize/capitalize.pipe';
import { SumsizecropPipe } from '../../pipe/sumsizecrop/sumsizecrop.pipe';
import { DatadevicePipe } from '../../pipe/datadevice/datadevice.pipe';
import { WalletcontainerPipe } from '../../pipe/walletcontainer/walletcontainer.pipe';
import { DatacontainerPipe } from '../../pipe/datacontainer/datacontainer.pipe';
import { DatawarehousePipe } from '../../pipe/datawarehouse/datawarehouse.pipe';
import { UniqFilterPipe } from '../../pipe/uniqfilter/uniqfilter.pipe';
import { DeviceDataMapperService } from '../../common/_services/deviceDataMapper.service';
import { OrderbyPipe } from '../../pipe/orderby/orderby.pipe';
import { DataequipmentPipe } from '../../pipe/dataequipment/dataequipment.pipe';
import { DatafieldPipe } from '../../pipe/datafield/datafield.pipe';
import { DataproductPipe } from '../../pipe/dataproduct/dataproduct.pipe';
import { DatauserPipe } from '../../pipe/datauser/datauser.pipe';
import { DatacropPipe } from '../../pipe/datacrop/datacrop.pipe';
import { MyfilterPipe } from '../../pipe/myfilter/myfilter.pipe';
import { TruncatePipe } from '../../pipe/truncate/truncate.pipe';
import { DatacommodityPipe } from '../../pipe/datacommodity/datacommodity.pipe';
import { CommoditybyfieldandyearPipe } from '../../pipe/commoditybyfieldandyear/commoditybyfieldandyear.pipe';
import { DatagroupPipe } from '../../pipe/datagroup/datagroup.pipe';
import { CustomCurrencyPipe } from '../../pipe/currency/mycurrencypipe.pipe';
import { HourFormatPipe } from '../../pipe/hourformat/hourformat.pipe';
import { TakeLanguageOfBrowserService } from '../../common/_services/takeLanguageOfBrowser.service';
import { LegalsService } from '../../common/_services/legals.service';
import { CitiesService } from '../../common/_services/cities.service';
import { CommonAlertService } from '../../common/_services/alert/commonAlert.service';
import { MappingService } from '../../common/_services/mapping.service';
import { FieldActivitySharedService } from '../../common/_services/fieldActivityShared.service';
import { TelemetryConfigurationService } from '../../common/_services/telemetryConfiguration.service';
import { StableService } from '../../common/_services/stable.service';
import { StableBoxService } from '../../common/_services/stableBox.service';
import { RoutingUtilitiesService } from '../../common/_services/routingUtlities.service';
import { appEffects } from '../../common/_effects';
import { reducers } from '../../common/_reducers';
import { GMapsService } from '../../common/_services/gmaps.service';
import { OperationsManagementService } from '../../common/_services/operations-management/operations-management.service';
import { XdataUtilsService } from '../../common/_services/xdata-utils.service';
import { CropSubUnitService } from '../../common/_services/cropSubUnit.service';
import { DefenceZoneService } from '../../common/_services/diseases/defenceZone.service';
import { InsectsZoneService } from '../../common/_services/insects/insectsZone.service';
import { ScriptLoaderService } from '../../common/_services/scriptLoader.service';
import { BatchService } from '../../common/_services/batch.service';
import { ExcelService } from '../../common/_services/excel.service';
import { UserSettingsService } from '../../common/_services/userSettings.service';
import { LocaleService } from '../../common/_services/locale.service';
import { ExportService } from '../../common/_services/export.service';
import { AnimalsService } from '../../common/_services/animals.service';
import { StableActivityService } from '../../common/_services/stableActivityService.service';
import { StableLoadsService } from '../../common/_services/stable-loads.service';
import { StableGroupService } from '../../common/_services/stableGroup.service';
import { StableActivityMultipleService } from '../../common/_services/stableActivityMultiple.service';
import { ChecksService } from '../../common/_services/checks.service';
import { CostProductsService } from '../../common/_services/financials/costProducts.service';
import { DocumentService } from '../../common/_services/document.service';
import { FieldsImportService } from '../../common/_services/fieldsImport.service';
import { FileManagementService } from '../../common/_services/fileManagement.service';
import { ISOXMLService } from '../../common/_services/ISOXML/ISOXML.service';
import { ClaasService } from '../../common/_services/claas.service';
import { MachineLocationService } from '../../common/_services/machinaries/machineLocation.service';
import { MachineLastStateService } from '../../common/_services/machinaries/machineLastState.service';
import { MachineUtilitiesService } from '../../common/_services/machinaries/machineUtilities.service';
import { RealTimeService } from '../../common/_services/realTime.service';
import { MapShapeService } from '../../common/_services/mapShape.service';
import { xSurveyUtilitiesService } from '../../common/_services/survey/xsurveyUtilities.service';
import { FinancialMetricsService } from '../../common/_services/financials/financialMetrics.service';
import { CnhService } from '../../common/_services/cnh.service';
import { CsvExportService } from '../../common/_services/common/csv-export.service';
import { DateExpiredService } from '../../common/_services/dateExpired.service';
import { EquipmentPartUsagesService } from '../../common/_services/equipmentPartUsages.service';
import { MachineEquipmentService } from '../../common/_services/machinaries/machineEquipment.service';
import { ToolConfigService } from '../../common/_services/toolConfig.service';
import { MachineFileService } from '../../common/_services/machinaries/machineFile.service';
import { RationsService } from '../../common/_services/rations/rations.service';
import { CommonContractDataService } from '../../common/_services/contract-management/common.service';
import { IrrigationZoneService } from '../../common/_services/irrigation/irrigationZone.service';
import { IrrigationAdviceService } from '../../common/_services/irrigation/irrigationAdvice.service';
import { SenseService } from '../../common/_services/sense/sense.service';
import { ParamMetaDataMapperService } from '../../common/_services/paramMetaDataMapper.service';
import { StatisticsService } from '../../common/_services/statistics.service';
import { RevenuesService } from '../../common/_services/financials/revenues.service';
import { CostGenericsService } from '../../common/_services/financials/costGenerics.service';
import { YnnovaService } from '../../common/_services/ynnova.service';
import { TableParamService } from '../../common/_services/tableParam.service';
import { MultiFarmService } from '../../common/_services/multiFarm.service';
import { QuotationService } from '../../common/_services/quotation.service';
import { DocumentOrderService } from '../../common/_services/documentOrder.service';
import { DeliveryNoteService } from '../../common/_services/deliveryNote.service';
import { InvoiceService } from '../../common/_services/invoice.service';
import { JohnDeereService } from '../../common/_services/johnDeere.service';
import { FieldViewService } from '../../common/_services/fieldView.service';
import { GoldoniService } from '../../common/_services/goldoni.service';
import { WayService } from '../../common/_services/way.service';
import { CoboService } from '../../common/_services/cobo.service';
import { MaterMaccService } from '../../common/_services/materMacc.service';
import { NutritionService } from '../../common/_services/nutrition/nutrition.service';
import { ValidatorsService } from '../../common/_services/validators.service';
import { XsurveyService } from '../../common/_services/xsurvey.service';
import { EmployeeCostSettingService } from '../../common/_services/financials/employeeCostSetting.service';
import { CostItemProductsService } from '../../common/_services/financials/costItemProducts.service';
import { CostItemGenericsService } from '../../common/_services/financials/costItemGenerics.service';
import { EmployeeActivityService } from '../../common/_services/employeeActivity.service';
import { FieldActivityPlanCostProductService } from '../../common/_services/fieldActivityPlanCostProduct.service';
import { FieldActivityPlanService } from '../../common/_services/fieldActivityPlan.service';
import { FieldActivityProgramService } from '../../common/_services/fieldActivityProgram.service';
import { AlertService } from '../../common/_services/alert.service';
import { AnalyticsService } from '../../common/_services/analytics.service';
import { TreeFilterService } from '../../common/_services/contract-management/treeFilter.service';
import { CostUtilsService } from '../../common/_services/financials/costUtils.service';
import { FinancialCostSettingService } from '../../common/_services/financials/financialCostSetting.service';
import { FieldActivityMultipleActionSimulationService } from '../../common/_services/fieldActivityMultipleActionSimulation.service';
import { RulesInPhrasesService } from '../../common/_services/rulesInPhrases.service';
import { InsectsChartsService } from '../../common/_services/insects/insectsCharts.service';
import { ChartsService } from '../../common/_services/charts.service';
import { EventsZoneService } from '../../common/_services/insects/eventsZone.service';
import { EquipmentCostSettingService } from '../../common/_services/financials/equipmentCostSetting.service';
import { ChemicalService } from '../../common/_services/chemical.service';
import { PlanService } from '../../common/_services/plan.service';
import { OperationCostSettingService } from '../../common/_services/financials/operationCostSetting.service';
import { SoilAnalysisService } from '../../common/_services/soilAnalysis.service';
import { SearchfilterDateRangePipe2 } from '../../pipe/searchfilterDateRange2/searchfilterDateRange2.pipe';
import { ProtocolsRegenerativeService } from '../../common/_services/regenerativeProtocols.service';
import { PracticesRegenerativeService } from '../../common/_services/regenerativePractices.service';
import { FarmDossierService } from '../../common/_services/farmDossier.service';
import { RegenerativePathService } from '../../sustainabilityV2/common/services/regenerativePath.service';
import { ConnectionHubService } from '../../common/_services/connection-hub/connection-hub.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(appEffects),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  //  tslint:disable-next-line:member-ordering
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        RoutingUtilitiesService,
        FormService,
        DataService,
        CommodityService,
        CropService,
        EquipmentService,
        LoadService,
        FarmService,
        FarmCadastralSheetService,
        FieldService,
        TagService,
        ExcelService,
        CompanyService,
        FieldActivityDeprecatedService,
        EquipmentActivityService,
        FieldGroupService,
        UserGroupService,
        MapService,
        ProductService,
        UserService,
        UsersroleService,
        DeviceService,
        DeviceDataService,
        MessageService,
        NoteService,
        FarmWeatherLocationService,
        WeatherHubService,
        GeoCodingService,
        UploadService,
        WarehouseService,
        ContainerService,
        ContainerActivityService,
        LandRegistryService,
        AlertGroupService,
        NotificationService,
        ChemicalService,
        TakeLanguageOfBrowserService,
        PaymentService,
        PlanService,
        PlantService,
        PaymentService,
        StoreModelService,
        SupplierService,
        LegalsService,
        ExportService,
        CsvExportService,
        CostUtilsService,
        TranslateService,
        EmployeeService,
        EmployeeCostSettingService,
        ChecksService,
        CommonService,
        XsurveyService,
        ProtocolsRegenerativeService,
        RegenerativePathService,
        CftService,
        ActivitiesTableService,
        PracticesRegenerativeService,
        DatagroupPipe,
        CommoditybyfieldandyearPipe,
        DatacommodityPipe,
        TruncatePipe,
        MyfilterPipe,
        DatacropPipe,
        DatauserPipe,
        DataproductPipe,
        DatafieldPipe,
        MapShapeService,
        DataequipmentPipe,
        AuthenticationService,
        OrderbyPipe,
        DatePipe,
        ParamMetaDataMapperService,
        DeviceDataMapperService,
        SatelliteService,
        UniqFilterPipe,
        DatawarehousePipe,
        DatacontainerPipe,
        CapitalizePipe,
        GMapsService,
        SenseService,
        WalletcontainerPipe,
        DatadevicePipe,
        //GoogleMapsAPIWrapper,
        CompanyAddressService,
        RulesInPhrasesService,
        FinancialMetricsService,
        FinancialCostSettingService,
        EquipmentCostSettingService,
        OperationCostSettingService,
        RationsService,
        CostProductsService,
        CostGenericsService,
        RevenuesService,
        CompanyContactService,
        PersonAddressService,
        PersonContactService,
        CustomerService,
        TableParamService,
        CertificationService,
        InsuranceService,
        SecurityService,
        CertificationDocService,
        InsuranceDocService,
        InvoiceDocService,
        SecurityDocService,
        CurrencyPipe,
        SumsizecropPipe,
        SearchfilterPipe,
        SearchfilterDateRangePipe,
        SearchfilterDateRangePipe2,
        CostItemProductsService,
        CostItemGenericsService,
        XdataUtilsService,
        CropMetricsService,
        CitiesService,
        ValidatorsService,
        IrrigationZoneService,
        IrrigationAdviceService,
        CommonAlertService,
        DefenceZoneService,
        PostService,
        EmployeeActivityService,
        OperationsManagementService,
        MappingService,
        MachineLocationService,
        MachineActivityService,
        FieldActivityPlanService,
        FieldActivityProgramService,
        BatchService,
        FieldActivityPlanCostProductService,
        EquipmentPartUsagesService,
        MachineEquipmentService,
        FieldActivityMultipleActionSimulationService,
        FieldActivityMultipleService,
        ISOXMLService,
        AgrirouterService,
        GeoserverService,
        DateExpiredService,
        MachineLastStateService,
        MachineUtilitiesService,
        AlertService,
        AllynavService,
        CoboService,
        ClaasService,
        CnhService,
        CropSubUnitService,
        DocumentService,
        WayService,
        GoldoniService,
        FieldViewService,
        JohnDeereService,
        AnalyticsService,
        FieldActivitySharedService,
        UserSettingsService,
        ToolConfigService,
        MultiFarmService,
        EmployeeDocService,
        FileManagementService,
        StatisticsService,
        InsectsZoneService,
        InsectsChartsService,
        ChartsService,
        FieldsImportService,
        TelemetryConfigurationService,
        RealTimeService,
        MachineFileService,
        MaterMaccService,
        StableService,
        StableBoxService,
        AnimalsService,
        StableGroupService,
        StableActivityMultipleService,
        StableActivityService,
        EventsZoneService,
        StableLoadsService,
        CustomCurrencyPipe,
        ConnectionLivestockService,
        CommonContractDataService,
        TreeFilterService,
        HourFormatPipe,
        QuotationService,
        DocumentOrderService,
        DeliveryNoteService,
        InvoiceService,
        YnnovaService,
        NutritionService,
        xSurveyUtilitiesService,
        ScriptLoaderService,
        MapLegendaService,
        LocaleService,
        SoilAnalysisService,
        ParcelService,
        ProtocolsRegenerativeService,
        PracticesRegenerativeService,
        FarmDossierService,
        ConnectionHubService,
        LivestockCoreDataService,
      ],
    };
  }
}
